import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { CategoryLevel } from '../enums/CategoryLevel'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'

export class CategoryFilterEntity {
  level?: CategoryLevel
  id?: number
  parentId?: number
  enabled?: boolean
  name?: string
  page?: number
  limit?: number
  searchWord?: string
  channel?: ChannelMiniEntity
  branch?: BranchMiniEntity
  categoryIds?: Array<number>
}
